"use client";

/**
 * ToolBody - Collapsible content wrapper for tool displays
 *
 * Wraps tool content in an animated collapse component
 * with consistent padding and styling.
 */

import type { ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { colors, spacing } from "@/ui/tokens";

export interface ToolBodyProps {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
}

export function ToolBody({
  isOpen,
  children,
  className,
  noPadding = false,
}: ToolBodyProps) {
  return (
    <AnimatePresence initial={false}>
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          style={{ overflow: "hidden" }}
        >
          <div
            className={cn(className)}
            style={{
              backgroundColor: colors.canvas.default,
              padding: noPadding ? 0 : spacing[4],
            }}
          >
            {children}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ToolBody;
